import Cookies from 'universal-cookie';
import { useQuery, useQueryClient } from '@tanstack/react-query';
import getMonitoringStatus from 'Api/monitoring/getMonitoringStatus';

import getMonitoringStatusResponse from './model/response/getMonitoringStatusResponse';

const useGetMonitoringStatus = ({ isEnabled }) => {
  const cookies = new Cookies();
  const queryClient = useQueryClient();
  const token = cookies.get('token');

  return useQuery({
    queryKey: ['monitoring-operator-status'],
    queryFn: async () => {
      const response = await getMonitoringStatus();

      const result = getMonitoringStatusResponse(response);

      queryClient.invalidateQueries({ queryKey: ['help-request-operator-status'] });

      return result;
    },

    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: Boolean(token) && Boolean(isEnabled),
  });
};

export default useGetMonitoringStatus;
